import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";
import { Icon, cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import { getFulfillmentStatusLabel } from "../../lib/fulfillment-status-label";
import { getOrderStatusVisual } from "../../lib/order-status-visual";

export const STATUS_OPTION_ITEM_CLASS =
  "grid min-h-12 grid-cols-[0.5rem_minmax(0,1fr)_1rem] items-start gap-x-2 px-2 py-2";

export const STATUS_FILTER_OPTION_ITEM_CLASS =
  `${STATUS_OPTION_ITEM_CLASS} pr-8 pl-2 ` +
  "data-[state=checked]:bg-muted/60 " +
  "[&>span:first-child]:right-2 [&>span:first-child]:left-auto [&>span:first-child]:top-2";

interface StatusOptionContentProps {
  status: MarketplaceFulfillmentStatus;
  selected?: boolean;
}

/** Shared status option anatomy for filters, editing, and bulk actions. */
export function StatusOptionContent({ status, selected = false }: StatusOptionContentProps) {
  const { t } = useTranslation();
  const visual = getOrderStatusVisual(status);

  return (
    <>
      <span
        aria-hidden
        className={cn("mt-1.5 inline-block size-1.5 rounded-full", visual.dotClass)}
      />
      <span className="min-w-0">
        <span className="block text-xs font-medium text-foreground">
          {getFulfillmentStatusLabel(t, status, "client")}
        </span>
        <span className="mt-0.5 block text-[11px] leading-4 text-muted-foreground">
          {t(`marketplace.orders.list.statusHint.${status}`)}
        </span>
      </span>
      {selected ? (
        <Icon name="check" size="sm" color="inherit" className="mt-0.5 text-primary" />
      ) : (
        <span aria-hidden />
      )}
    </>
  );
}
